export default __webpack_public_path__ + "static/media/city.53cb5430.svg";